import { FOCUSABLE_ELEMENT_SELECTOR } from "../../../constants/constants";

const FALLBACK_TRANSITION_DURATION = 400;

let pendingScrollTimer: ReturnType<typeof setTimeout> | undefined;

const getTransitionDuration = (): number => {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue("--animation-duration")
    .trim();

  if (!value) {
    return FALLBACK_TRANSITION_DURATION;
  }

  if (value.endsWith("ms")) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : FALLBACK_TRANSITION_DURATION;
  }

  const parsed = parseFloat(value) * 1000;
  return Number.isFinite(parsed) ? parsed : FALLBACK_TRANSITION_DURATION;
};

export const scrollToAssumptionGroup = (assumptionGroup: number): void => {
  if (typeof window === "undefined") {
    return;
  }

  clearTimeout(pendingScrollTimer);

  const nextAssumptionGroup = document.getElementById(
    `assumption-group-${assumptionGroup}`,
  );

  const firstFocusable = nextAssumptionGroup?.querySelector(
    FOCUSABLE_ELEMENT_SELECTOR,
  ) as HTMLElement;

  if (firstFocusable) {
    firstFocusable.focus({ preventScroll: true });
  }

  pendingScrollTimer = setTimeout(() => {
    if (nextAssumptionGroup) {
      nextAssumptionGroup.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      const submission = document.getElementById("mobius-submit-action");
      submission?.scrollIntoView({ behavior: "smooth" });
    }
  }, getTransitionDuration());
};
